export interface FilterCategoryHeaderProps {
  title: string;
}

const FilterCategoryHeader = (props: FilterCategoryHeaderProps) => {
  return <h2 className="font-extended font-base">{props.title}</h2>;
};

export default FilterCategoryHeader;
